export default "__VITE_PUBLIC_ASSET__be143502__"